import { render, staticRenderFns } from "./depart-add-or-update.vue?vue&type=template&id=1b0dbc38&scoped=true&"
import script from "./depart-add-or-update.vue?vue&type=script&lang=js&"
export * from "./depart-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0dbc38",
  null
  
)

export default component.exports